import { render, staticRenderFns } from "./TariffContent.vue?vue&type=template&id=784ad358&scoped=true"
import script from "./TariffContent.vue?vue&type=script&lang=js"
export * from "./TariffContent.vue?vue&type=script&lang=js"
import style0 from "./TariffContent.vue?vue&type=style&index=0&id=784ad358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784ad358",
  null
  
)

export default component.exports